import React from 'react'
import { connect } from 'react-redux'
import { selectCursorNode } from '../../store/cursor'
import { getLabelForNode } from './getLabelForNode'
import { PathView } from './PathView'
import { NavLink, withRouter } from 'react-router-dom'
import { Markdown } from '../Markdown'
import { SyncStatusIndicator } from '../SyncStatusIndicator'

const TitleViewComponent = ({ titleNode }) => {
    const label = getLabelForNode(titleNode)
    return (
        <div id="titleview">
            <NavLink className="titleview-item" activeClassName="titleview-item-active" exact to={'/settings'}>
                <i className="fal fa-cog"></i>
            </NavLink>
            <NavLink className="titleview-item" activeClassName="titleview-item-active" exact to={'/settings'}>
                <SyncStatusIndicator />
            </NavLink>
            <PathView node={titleNode} />
            <h1>
                <Markdown>{label}</Markdown>
            </h1>
        </div>
    )
}

const mapStateToProps = (state, _ownProps) => {
    const cursorNode = selectCursorNode(state)

    const titleNode = cursorNode ? cursorNode.parent : undefined

    return { titleNode }
}

export const TitleView = withRouter(connect(mapStateToProps)(TitleViewComponent))
